if (!customElements.get('jonis-heart-options')) {
  customElements.define('jonis-heart-options', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.root = this.closest('product-info');
      this.form = document.getElementById(this.dataset.formId);
      if (!this.root || !this.form) return;
      this.combinations = JSON.parse(this.querySelector('[data-heart-combinations]').textContent);
      const signal = this.abort.signal;
      this.addEventListener('change', () => this.updateImage(), { signal });
      this.form.querySelector('[name="id"]').addEventListener('change', () => this.updateImage(), { signal });
      this.unsubscribe?.();
      if (typeof subscribe === 'function') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (String(data?.sectionId) === this.dataset.section) this.updateImage();
        });
      }
      this.dialog = this.root.querySelector('.jonis-heart-gallery__dialog');
      this.root.querySelector('[data-heart-zoom]')?.addEventListener('click', () => this.dialog?.showModal(), { signal });
      this.root.querySelector('[data-heart-close]')?.addEventListener('click', () => this.dialog?.close(), { signal });
      this.dialog?.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); }, { signal });
      this.updateImage();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.unsubscribe?.();
    }
    updateImage() {
      const variant = this.form.querySelector('[name="id"]').value;
      const ribbon = this.querySelector('input:checked')?.value || 'תכלת';
      const image = this.combinations[variant]?.[ribbon];
      if (!image) return;
      this.root.querySelectorAll('[data-heart-image], [data-heart-zoom-image]').forEach(element => {
        if (element.getAttribute('src') !== image.url) element.src = image.url;
        element.alt = image.alt;
      });
    }
  });
}
